export default __webpack_public_path__ + "static/media/VideoActive.483a756f.svg";